import React, { useCallback, useEffect, useRef, useState } from "react";
import { axiosRequest } from "../../utility/axios";
import { HANDS, handLabel, rankPickers, previewHand, rankChar } from "./hands.js";

// Dealer page: log a player's big hand (Full House or better). Same personal-PIN login
// and stored session as /dealer-tip, so a dealer signed in there is signed in here too.
const API_URL = process.env.REACT_APP_API_URL;
const AUTH_KEY = "dealer_tip_auth";

export const CSS = `
*,*::before,*::after{box-sizing:border-box;}
.dh-root{min-height:100vh;min-height:100dvh;background:#0f1115;color:#f2f2f2;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;padding-bottom:40px;}
.dh-header{position:sticky;top:0;z-index:20;background:#161922;border-bottom:1px solid #262a36;padding:12px 16px;padding-top:max(12px,env(safe-area-inset-top));display:flex;align-items:center;justify-content:space-between;gap:10px;}
.dh-header h1{font-size:17px;font-weight:700;margin:0;}
.dh-title{min-width:0;}
.dh-title h1{white-space:nowrap;}
.dh-who{font-size:12.5px;color:#9aa0ac;margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.dh-logout{background:none;border:1px solid #333846;color:#c9cdd6;font-size:12px;padding:6px 10px;border-radius:8px;white-space:nowrap;}
.dh-body{padding:16px;max-width:640px;margin:0 auto;}
.dh-card{background:#1a1d27;border:1px solid #262a36;border-radius:14px;padding:16px;margin-bottom:14px;}
.dh-field{margin-bottom:16px;}
.dh-field:last-child{margin-bottom:0;}
.dh-field label{display:block;font-size:12.5px;color:#a6abb6;margin-bottom:6px;font-weight:600;}
.dh-input{width:100%;padding:13px 12px;border-radius:10px;border:1px solid #333846;background:#12141b;color:#f2f2f2;font-size:16px;-webkit-appearance:none;appearance:none;}
.dh-input:focus{outline:none;border-color:#f6c445;}
.dh-player{margin-top:8px;font-size:13.5px;min-height:18px;}
.dh-player.ok{color:#7be0a0;}
.dh-player.bad{color:#ff8a8a;}
.dh-hands{display:grid;grid-template-columns:1fr 1fr;gap:10px;}
.dh-hand{padding:16px 10px;border-radius:12px;border:2px solid #333846;background:#12141b;color:#f2f2f2;font-size:15px;font-weight:700;text-align:center;cursor:pointer;line-height:1.25;}
.dh-hand small{display:block;font-size:11.5px;font-weight:500;color:#9aa0ac;margin-top:4px;}
.dh-hand.on{border-color:#f6c445;background:#2a2412;color:#f6c445;}
.dh-ranks{display:grid;grid-template-columns:repeat(7,1fr);gap:6px;}
.dh-rank{padding:11px 0;border-radius:9px;border:2px solid #333846;background:#12141b;color:#f2f2f2;font-size:16px;font-weight:800;text-align:center;cursor:pointer;}
.dh-rank.on{border-color:#f6c445;background:#2a2412;color:#f6c445;}
.dh-rank:disabled{opacity:.25;}
.dh-preview{margin-top:4px;padding:12px;border-radius:10px;background:#2a2412;border:1px solid #f6c445;color:#f6c445;font-weight:800;font-size:15px;text-align:center;}
/* keeps Save in thumb reach on phones once the ranks push it below the fold */
.dh-save-bar{position:sticky;bottom:0;z-index:10;margin:0 -16px;padding:12px 16px calc(12px + env(safe-area-inset-bottom));
  background:linear-gradient(to bottom,rgba(15,17,21,0),#0f1115 35%);}
.dh-btn{width:100%;padding:14px;border-radius:12px;border:none;font-size:15.5px;font-weight:700;cursor:pointer;background:#f6c445;color:#1d1503;}
.dh-btn:disabled{opacity:.5;}
.dh-toast{position:fixed;left:50%;bottom:calc(88px + env(safe-area-inset-bottom));transform:translateX(-50%);background:#262a36;color:#fff;padding:11px 18px;border-radius:10px;font-size:13.5px;z-index:100;box-shadow:0 8px 24px rgba(0,0,0,.4);max-width:90vw;text-align:center;}
.dh-toast.err{background:#4a1c22;color:#ffb3b3;}
.dh-login-wrap{min-height:100vh;min-height:100dvh;display:flex;align-items:center;justify-content:center;padding:20px;}
.dh-login-card{background:#1a1d27;border:1px solid #262a36;border-radius:18px;padding:28px 22px;width:100%;max-width:360px;}
.dh-login-card h1{text-align:center;font-size:19px;margin:0 0 4px;}
.dh-login-card p{text-align:center;color:#9aa0ac;font-size:12.5px;margin:0 0 22px;}
.dh-login-err{color:#ff8a8a;font-size:12.5px;text-align:center;margin-top:10px;}
.dh-section-title{font-size:12.5px;font-weight:700;color:#8b8f99;text-transform:uppercase;letter-spacing:.4px;margin:22px 0 8px;}
.dh-row{display:flex;align-items:center;justify-content:space-between;gap:10px;background:#1a1d27;border:1px solid #262a36;border-radius:12px;padding:11px 14px;margin-bottom:8px;}
.dh-row-main{font-weight:700;font-size:14px;}
.dh-row-sub{font-size:11.5px;color:#9aa0ac;margin-top:2px;}
.dh-void{font-size:11px;font-weight:800;padding:3px 9px;border-radius:100px;background:#3a1a1f;color:#ff8a8a;}
.dh-empty{text-align:center;color:#7d818c;padding:20px 10px;font-size:13px;}
.dh-row > div:first-child{min-width:0;}
.dh-row-main,.dh-row-sub{overflow-wrap:anywhere;}
@media (max-width:360px){
  .dh-body{padding:12px;}
  .dh-save-bar{margin:0 -12px;padding-left:12px;padding-right:12px;}
  .dh-card{padding:13px;}
  .dh-header h1{font-size:15.5px;}
  .dh-hand{padding:13px 6px;font-size:14px;}
  .dh-hands{gap:8px;}
  .dh-ranks{gap:5px;}
  .dh-rank{padding:10px 0;font-size:15px;}
}
`;

const fmtTime = (d) => (d ? new Date(d).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "--");

export default function DealerHandPage() {
  const [auth, setAuth] = useState(() => {
    try { return JSON.parse(localStorage.getItem(AUTH_KEY) || "null"); } catch { return null; }
  });
  const [pin, setPin] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginErr, setLoginErr] = useState("");

  const [toast, setToast] = useState(null);
  const toastTimer = useRef(null);
  const showToast = useCallback((msg, err = false) => {
    setToast({ msg, err });
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), 3200);
  }, []);

  const api = useCallback(
    async (method, path, data) => {
      const res = await axiosRequest(method, `${API_URL}${path}`, null, data, auth?.token ? { "dealer-token": auth.token } : {});
      const httpStatus = res?.response?.status;
      if (httpStatus === 401 || httpStatus === 403) {
        localStorage.removeItem(AUTH_KEY);
        setAuth(null);
        return { ok: false, error: "Session expired, please log in again" };
      }
      if (!res || !res.data) {
        return { ok: false, error: res?.response?.data?.error || res?.message || "Network error" };
      }
      return { ok: true, payload: res.data };
    },
    [auth]
  );

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!pin.trim()) return;
    setLoginLoading(true);
    setLoginErr("");
    const { ok, payload, error } = await api("post", "/dealer-tip/login", { pin: pin.trim() });
    setLoginLoading(false);
    if (!ok) return setLoginErr(error || "Login failed");
    if (!payload?.status) return setLoginErr(payload?.message || "Invalid PIN");
    const next = { token: payload.token, employee_name: payload.employee_name };
    localStorage.setItem(AUTH_KEY, JSON.stringify(next));
    setAuth(next);
  };

  const handleLogout = () => {
    localStorage.removeItem(AUTH_KEY);
    setAuth(null);
    setPin("");
  };

  if (!auth?.token) {
    return (
      <div className="dh-root">
        <style>{CSS}</style>
        <div className="dh-login-wrap">
          <div className="dh-login-card">
            <h1>🃏 Hand Entry</h1>
            <p>Dealer entry — enter your personal PIN to continue</p>
            <form onSubmit={handleLogin}>
              <div className="dh-field">
                <label>PIN</label>
                <input className="dh-input" type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} placeholder="Enter your PIN" autoFocus />
              </div>
              <button className="dh-btn" disabled={loginLoading} type="submit">{loginLoading ? "Checking..." : "Enter"}</button>
              {loginErr && <div className="dh-login-err">{loginErr}</div>}
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dh-root">
      <style>{CSS}</style>
      <header className="dh-header">
        <div className="dh-title">
          <h1>🃏 Hand Entry</h1>
          <div className="dh-who">{auth.employee_name}</div>
        </div>
        <button className="dh-logout" onClick={handleLogout}>Log out</button>
      </header>
      <div className="dh-body">
        <HandForm api={api} showToast={showToast} />
      </div>
      {toast && <div className={`dh-toast${toast.err ? " err" : ""}`}>{toast.msg}</div>}
    </div>
  );
}

// Also used by the /hand-entries staff page (admin.js) with its own api + paths and no
// "recent entries" list.
export const DEALER_PATHS = { entries: "/dealer-hand/entries", lookup: "/dealer-hand/player-lookup" };

export function HandForm({ api, showToast, paths = DEALER_PATHS, showRecent = true, onSaved }) {
  const [playerId, setPlayerId] = useState("");
  const [player, setPlayer] = useState(null); // { playerId, name } once confirmed
  const [lookupState, setLookupState] = useState("idle"); // idle | checking | found | missing
  const [hand, setHand] = useState("");
  const [ranks, setRanks] = useState({ rank: null, rank2: null });
  const pickHand = (key) => { setHand(key); setRanks({ rank: null, rank2: null }); };
  const preview = previewHand(hand, ranks.rank, ranks.rank2);
  const [saving, setSaving] = useState(false);
  const [entries, setEntries] = useState([]);

  const loadEntries = useCallback(async () => {
    if (!showRecent) return;
    const { ok, payload } = await api("get", paths.entries);
    if (ok) setEntries(payload?.entries || []);
  }, [api, paths.entries, showRecent]);
  useEffect(() => { loadEntries(); }, [loadEntries]);

  // Confirm the player ID as the dealer types (debounced), so a typo is caught before saving.
  useEffect(() => {
    const id = playerId.trim();
    setPlayer(null);
    if (!id) return setLookupState("idle");
    setLookupState("checking");
    const t = setTimeout(async () => {
      const { ok, payload } = await api("get", `${paths.lookup}?player_id=${encodeURIComponent(id)}`);
      if (!ok) return setLookupState("idle");
      if (payload?.found) { setPlayer(payload.player); setLookupState("found"); }
      else setLookupState("missing");
    }, 400);
    return () => clearTimeout(t);
  }, [playerId, api, paths.lookup]);

  const submit = async (e) => {
    e.preventDefault();
    if (!player) return showToast("Enter a valid Player ID", true);
    if (!hand) return showToast("Select the hand", true);
    if (!preview) return showToast("Select the card ranks", true);
    setSaving(true);
    const { ok, payload } = await api("post", paths.entries, { player_id: player.playerId, hand, rank: ranks.rank, rank2: ranks.rank2 });
    setSaving(false);
    if (!ok || !payload?.status) return showToast(payload?.message || "Could not save hand", true);
    showToast(payload.message || "Hand saved");
    setPlayerId("");
    pickHand("");
    loadEntries();
    if (onSaved) onSaved(payload);
  };

  return (
    <>
      <form onSubmit={submit}>
        <div className="dh-card">
          <div className="dh-field">
            <label>Player ID</label>
            <input
              className="dh-input" value={playerId} onChange={(e) => setPlayerId(e.target.value)}
              placeholder="Enter Player ID" autoCapitalize="characters" autoComplete="off" autoCorrect="off"
            />
            <div className={`dh-player${lookupState === "found" ? " ok" : lookupState === "missing" ? " bad" : ""}`}>
              {lookupState === "checking" && "Checking…"}
              {lookupState === "found" && `✓ ${player.playerId}${player.name ? ` — ${player.name}` : ""}`}
              {lookupState === "missing" && "No player found with this ID"}
            </div>
          </div>
          <div className="dh-field">
            <label>Hand</label>
            <div className="dh-hands">
              {HANDS.map((h) => (
                <button type="button" key={h.key} className={`dh-hand${hand === h.key ? " on" : ""}`} onClick={() => pickHand(h.key)}>
                  {h.label}
                  {h.sub && <small>{h.sub}</small>}
                </button>
              ))}
            </div>
          </div>
          {rankPickers(hand).map((pk) => (
            <div className="dh-field" key={pk.field}>
              <label>{pk.label}</label>
              <div className="dh-ranks">
                {pk.ranks.map((r) => (
                  <button
                    type="button" key={r} className={`dh-rank${ranks[pk.field] === r ? " on" : ""}`}
                    // a full house's pair can't share the three-of-a-kind's rank
                    disabled={hand === "FULL_HOUSE" && pk.field === "rank2" && ranks.rank === r}
                    onClick={() => setRanks((cur) => ({ ...cur, [pk.field]: r, ...(pk.field === "rank" && cur.rank2 === r ? { rank2: null } : {}) }))}
                  >{rankChar(r)}</button>
                ))}
              </div>
            </div>
          ))}
          {preview && <div className="dh-preview">{preview}</div>}
        </div>
        <div className="dh-save-bar">
          <button className="dh-btn" disabled={saving || !player || !preview} type="submit">
            {saving ? "Saving..." : "Save Hand"}
          </button>
        </div>
      </form>

      {showRecent && (<>
      <div className="dh-section-title">Your Recent Entries</div>
      {!entries.length ? (
        <div className="dh-empty">No entries yet.</div>
      ) : (
        entries.map((e) => (
          <div className="dh-row" key={e._id}>
            <div>
              <div className="dh-row-main">{e.hand_desc || handLabel(e.hand)}</div>
              <div className="dh-row-sub">{e.player_id}{e.player_name ? ` — ${e.player_name}` : ""} · {fmtTime(e.createdAt)}</div>
            </div>
            {e.voided && <span className="dh-void">Voided</span>}
          </div>
        ))
      )}
      </>)}
    </>
  );
}
